import { render, staticRenderFns } from "./SavFooter.vue?vue&type=template&id=5a3d5132&"
import script from "./SavFooter.vue?vue&type=script&lang=js&"
export * from "./SavFooter.vue?vue&type=script&lang=js&"
import style0 from "./SavFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports